package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SportsMotorsportsW500Rounded: ImageVector
    get() {
        if (_sportsMotorsportsW500Rounded != null) {
            return _sportsMotorsportsW500Rounded!!
        }
        _sportsMotorsportsW500Rounded = Builder(name = "SportsMotorsportsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.0f, 480.0f)
                close()
                moveTo(560.0f, 717.13f)
                quadToRelative(98.8f, 0.0f, 167.97f, -69.4f)
                quadToRelative(69.16f, -69.4f, 69.16f, -168.21f)
                quadToRelative(0.0f, -99.8f, -72.78f, -168.23f)
                quadToRelative(-72.78f, -68.42f, -174.35f, -68.42f)
                quadToRelative(-46.57f, 0.0f, -90.97f, 10.76f)
                reflectiveQuadToRelative(-85.44f, 31.8f)
                lineTo(470.0f, 324.0f)
                quadToRelative(41.0f, 17.0f, 65.5f, 52.5f)
                reflectiveQuadTo(560.0f, 456.0f)
                quadToRelative(0.0f, 60.0f, -41.5f, 102.0f)
                reflectiveQuadTo(418.0f, 600.0f)
                lineTo(164.63f, 600.0f)
                quadToRelative(-1.52f, 23.04f, -1.64f, 52.59f)
                quadToRelative(-0.12f, 29.54f, -0.12f, 64.54f)
                lineTo(560.0f, 717.13f)
                close()
                moveTo(178.87f, 520.0f)
                lineTo(416.0f, 520.0f)
                quadToRelative(27.0f, 0.0f, 45.5f, -18.5f)
                reflectiveQuadTo(480.0f, 456.0f)
                quadToRelative(0.0f, -19.0f, -10.5f, -34.5f)
                reflectiveQuadTo(440.0f, 398.0f)
                lineToRelative(-144.65f, -58.57f)
                quadToRelative(-42.0f, 37.24f, -71.5f, 83.77f)
                quadToRelative(-29.5f, 46.52f, -44.98f, 96.8f)
                close()
                moveTo(560.0f, 808.13f)
                lineTo(162.87f, 808.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-90.0f)
                quadToRelative(0.0f, -98.24f, 37.84f, -184.7f)
                quadToRelative(37.83f, -86.45f, 102.65f, -150.91f)
                quadToRelative(64.81f, -64.45f, 152.13f, -102.05f)
                quadToRelative(87.31f, -37.6f, 185.51f, -37.6f)
                quadToRelative(69.67f, 0.0f, 131.11f, 25.72f)
                quadToRelative(61.43f, 25.71f, 107.51f, 70.29f)
                quadToRelative(46.08f, 44.58f, 72.79f, 104.25f)
                quadToRelative(26.72f, 59.67f, 26.72f, 128.35f)
                quadToRelative(-0.24f, 67.67f, -25.96f, 127.49f)
                quadToRelative(-25.71f, 59.81f, -70.29f, 104.39f)
                quadToRelative(-44.58f, 44.57f, -104.39f, 70.17f)
                quadToRelative(-59.82f, 25.6f, -127.49f, 25.6f)
                close()
            }
        }
        .build()
        return _sportsMotorsportsW500Rounded!!
    }

private var _sportsMotorsportsW500Rounded: ImageVector? = null
